import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../i18n/content';

const About = () => {
  const { language } = useLanguage();
  const t = content[language].about;
  const fadeInUp = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-100px" },
    transition: { duration: 0.8, ease: "easeOut" }
  };



  return (
    <section id="about" className="relative px-4 md:px-16 premium-bg-3">
      <div className="container mx-auto max-w-6xl relative z-10 premium-content-layer py-32 md:py-48">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 lg:gap-24">
          
          {/* Left Column - Sticky Title */}
          <div className="relative">
            <div className="md:sticky md:top-1/3 flex flex-col justify-start pt-10">
              <motion.div
                {...fadeInUp}
              >
                <h2 className="font-display text-4xl md:text-5xl lg:text-7xl font-bold tracking-wide leading-[1.1] mb-6">
                  <span className="text-white">{t.titleLine1} </span>
                  <span className="text-secondary block mt-2">{t.titleLine2}</span>
                </h2>
                <div className="h-2 w-24 bg-secondary rounded-full mt-8 opacity-80"></div>
              </motion.div>
            </div>
          </div>

          {/* Right Column - Scrolling Content */}
          <div className="flex flex-col gap-24 md:pt-48 pb-32">
            {t.points.map((text, i) => (
              <motion.div 
                key={i}
                className="bg-transparent border border-white/10 rounded-3xl p-8 md:p-10 backdrop-blur-sm"
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, margin: "-15%" }}
                transition={{ duration: 0.7, type: "spring", bounce: 0.3 }}
              >
                <div className="flex items-start gap-5">
                  <div className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center border border-red-500/20 bg-red-500/10">
                    <span className="text-red-400 text-xl">✕</span>
                  </div>
                  <span className="text-xl md:text-2xl text-white/90 font-light leading-relaxed mt-1">
                    {text}
                  </span>
                </div>
              </motion.div>
            ))}

            <motion.div 
              className="text-center bg-transparent border border-secondary/30 rounded-[2.5rem] p-10 mt-16 shadow-none"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <h3 className="text-3xl md:text-4xl font-display font-bold text-white mb-6">
                {t.closingTitle} <span className="text-secondary">{t.closingTitleHighlight}</span>
              </h3>
              <p className="text-xl md:text-2xl text-white/80 font-light">
                {t.closingText}
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

